import { IUser } from "../context/auth";
import { IRegisterData } from "../context/register";
import { Constants } from "../utils"


interface ITokens {
    refresh: string,
    access: string
}

export class Storage {
    static saveTokens(data: ITokens) {
        return localStorage.setItem(Constants.storage.tokens, JSON.stringify(data))
    }

    static async getTokens(): Promise<ITokens> {
        const tokens = JSON.parse(localStorage.getItem(Constants.storage.tokens) as string);
        return Promise.resolve(tokens);
    }

    static saveUser(data: IUser) {
        return localStorage.setItem(Constants.storage.user, JSON.stringify(data))
    }

    static async getUser(): Promise<IUser> {
        const User = JSON.parse(localStorage.getItem(Constants.storage.user) as string);
        return Promise.resolve(User);
    }

    static async clearAll() {
        return localStorage.clear()
    }
}

export class SessionStorage {
    static async saveRegister(data: IRegisterData) {
        return sessionStorage.setItem(Constants.storage.register, JSON.stringify(data))
    }

    static async getRegisterData(): Promise<IRegisterData> {
        const data = JSON.parse(sessionStorage.getItem(Constants.storage.register) as string);
        return Promise.resolve(data);
    }

    static async saveStep(step: number) {
        return sessionStorage.setItem(Constants.storage.step, JSON.stringify(step))
    }

    static async getStep(): Promise<number> {
        const data = JSON.parse(sessionStorage.getItem(Constants.storage.step) as string);
        return Promise.resolve(data);
    }
}